export default {
  assetId: {
    defaultMessage: 'Asset ID',
    description: 'Asset view form | label for field',
  },
  assetOwner: {
    defaultMessage: 'Asset Owner',
    description: 'Asset view form | label for field',
  },
  reference: {
    defaultMessage: 'Reference No',
    description: 'Asset view form | label for field',
  },
  assetUpdated: {
    defaultMessage: 'The asset has been updated successfully.',
    description: 'Asset view form | success update messages',
  },
  back: {
    defaultMessage: 'Back',
    description: 'Asset view | back button',
  },
  cancel: {
    defaultMessage: 'Cancel',
    description: 'Asset view form | cancel button label',
  },
  description: {
    defaultMessage: 'Vehicle Description',
    description: 'Asset view form | vehicle description',
  },
  durationExpiration: {
    defaultMessage: 'Duration expires at 23:59 of the final share day.',
    description: 'Asset view | duration expiration information in the share box',
  },
  edit: {
    defaultMessage: 'Edit',
    description: 'Asset view | edit button label',
  },
  locationNotAvailable: {
    defaultMessage: 'Location currently not available',
    description: 'Asset view | location not available text on the turned off map',
  },
  noLongerAvailableContent: {
    defaultMessage:
      'Bridge has expired or been removed. Contact the vehicle owner for more information. Download the asset location data in csv format.',
    description: 'Asset view | content of alert, when asst not exists.',
  },
  noLongerAvailableHeading: {
    defaultMessage: 'Vehicle ID: {assetId} is no longer available.',
    description: 'Asset view | heading of alert, when asst not exists.',
  },
  ptu: {
    defaultMessage: 'PTU',
    description: 'Asset view | label in heading',
  },
  remaining: {
    defaultMessage: 'Remaining',
    description: 'Asset view | label for share box',
  },
  remainingDays: {
    defaultMessage: `{daysCount, plural,
      =0 {{daysCount} days}
      one {{daysCount} day}
      other {{daysCount} days}
    }`,
    description: 'Asset view | remaining days text with value in the share box',
  },
  select: {
    defaultMessage: 'Select',
    description: 'Asset view form | select placeholder',
  },
  shareDuration: {
    defaultMessage: 'Share Duration',
    description: 'Asset view | label for share box',
  },
  submit: {
    defaultMessage: 'Update',
    description: 'Asset view form | submit button label',
  },
  trackingIdentifier: {
    defaultMessage: 'Tracking Identifier',
    description: 'Asset view form | label for field',
  },
  trackingPausedContent: {
    defaultMessage:
      'The asset owner has paused location sharing for this asset. Contact the asset owner for more information.',
    description: 'Asset view | heading of alert, when asst not exists.',
  },
  trackingPausedHeading: {
    defaultMessage: 'Location sharing is currently paused.',
    description: 'Asset view | heading of alert, when asst not exists.',
  },
  trackingSource: {
    defaultMessage: 'Tracking Source',
    description: 'Asset view form | label for field',
  },
  vehicle: {
    defaultMessage: 'Vehicle',
    description: 'Asset view | label in heading',
  },
  vehicleLicensePlate: {
    defaultMessage: 'Vehicle License Plate',
    description: 'Asset view form | label for field',
  },
  vehicleMake: {
    defaultMessage: 'Vehicle Make',
    description: 'Asset view form | label for field',
  },
  vehicleModel: {
    defaultMessage: 'Vehicle Model',
    description: 'Asset view form | label for field',
  },
  view: {
    defaultMessage: 'View',
    description: 'All assets table | View button label',
  },
  vinNumber: {
    defaultMessage: 'VIN number',
    description: 'Asset view form | label for field',
  },
  lastSeen: {
    defaultMessage: 'Last seen',
    description: 'Asset view form | label for field',
  },
  editDisabled: {
    defaultMessage: 'Asset cannot be edited while in a Smart Share. End Smart Share to edit.',
    escription: 'Asset view form | button disabled asset cannot edit',
  },
  deleteDisabled: {
    defaultMessage: 'Asset cannot be deleted while in a Smart Share. End Smart Share to delete.',
    escription: 'Asset view form | button disabled asset cannot edit',
  },
  tags: {
    defaultMessage: 'Tags',
    description: 'Asset view form | label for field',
  }
} as const
